import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, createSearchParams, Link } from "react-router-dom";
import { Formik, Form } from 'formik'
import logo from '../assets/images/MGL.png'
//import logoWebp from '../assets/images/PMS.webp'
import logoJpg from '../assets/images/PMS.jpg'
import { setAuth } from '../redux/features/auth.feature'
import { toast } from 'react-toastify'
import axios from 'axios';
import { BASE_URL } from "../utils/commonUrl";
import { ProgressSpinner } from "primereact/progressspinner";
import * as Yup from "yup";
import TextField from "../components/TextField";
import '../css/login.css'

import { Modal, Button } from 'react-bootstrap'


const Login = () => {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const [credentials, setcredentials] = useState({ username: '', password: '' });
    const [isLoading, setIsLoading] = useState(false)
    let token = localStorage.token

    const [isShow, invokeModal] = React.useState(false)
    const initModal = () => {
        return invokeModal(!false)
    }

    const closeModal = () => {
        invokeModal(false);
    }

    const notify = (message) => toast.info(message);

    const onLoginSubmit = async data => {
        //  e.preventDefault()
        //console.log(data)
        const payload = {
            user: { name: credentials.username, factory: 'MGL', email: 'anik@bitopibd.com' },
            token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'
        }
        //const url = `https://localhost:7011/api/login/UserLoginDummy`;
        const url = `https://apps.bitopibd.com/PMSCoreAPI/api/login/UserLoginDummy`;
        var _dbModel = { UserName: data.username, Password: data.password }
        //console.log(_dbModel);
        try {
            setIsLoading(true)
            //const response = await axios.post(url, {});
            const response = await axios.post(url, JSON.stringify(_dbModel));
            setIsLoading(false)
            //console.log(response.data)
            notify(response.data.message)
            if (response.status === 200) {
                const { registerID } = response.data
                const userResponse = await axios.get(BASE_URL + "/api/Utility/UserProfile/" + registerID);                
                if (userResponse.status === 200) {
                    console.log(userResponse);
                    const { employeeCode } = userResponse.data[0]
                    if (employeeCode === undefined || employeeCode === null) {
                        return navigate({
                            pathname: "/register",
                            search: createSearchParams({
                                registerID: registerID
                            }).toString()
                        });
                    } else {
                        payload.user = userResponse.data[0]
                        payload.user.registerID = registerID
                        dispatch(setAuth(payload));
                        window.location.reload();
                        return navigate('/')
                    }

                }


            }
        } catch (e) {
            const { message } = e.response.data;
            notify(message)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        console.log("token", typeof (token))
        if (token !== undefined) {
            return navigate('/')
        }
    }, [])


    const validation = Yup.object({

        username: Yup.string().required("This field is required"),
        password: Yup.string().required("This field is required"),

    })

    return (
        <section className="ftco-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6 text-center mb-5">
                        {/* <h2 className="heading-section">Login #04</h2> */}
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-12 col-lg-10">
                        <div className="wrap d-md-flex">
                            <div>
                                <img src={logoJpg} alt="profile" className='imgSize' />
                            </div>
                            <div className="login-wrap p-4 p-md-5">
                                <div className="">


                                    <Formik validationSchema={validation}
                                        initialValues={{ username: '', password: '' }}
                                        onSubmit={onLoginSubmit}>
                                        {formik =>
                                        (<>
                                            <Form>
                                                <div className="w-100">
                                                    <h3 className="mb-4">Sign In</h3>
                                                </div>
                                                <div className='signin-form'>
                                                    <div className='form-group mb-3'>
                                                        <label className='label' for='name'>Username</label>
                                                        <TextField type="text" name="username" className='form-control' style={{ width: '100%' }} placeholder="Enter User Name.." />
                                                    </div>
                                                    <div className='form-group mb-3'>
                                                        <label className='label' for='password'>Password</label>
                                                        <TextField type="password" name="password" placeholder="Enter Password.." />
                                                    </div>
                                                    <button type="submit" disabled={isLoading} style={{ width: '100%' }} className="form-control btn btn-primary rounded submit px-3"><i class="bi bi-unlock"></i> Sign In</button><br></br>
                                                    <br />
                                                    <div className='form-group d-md-flex'>
                                                        <div className='w-50'>
                                                            <Link className="m-2" to={"/register"}><i class="bi bi-person-plus-fill"></i> Register Here</Link><br></br><br></br>
                                                        </div>
                                                        <div className='w-50'>
                                                            <Link className="m-2" to={"/forget-password"}><i class="bi bi-key-fill"></i> Forget Password?</Link>
                                                        </div>
                                                    </div>
                                                    {isLoading ? <ProgressSpinner style={{ width: '50px', height: '50px', marginLeft: '10px', marginTop: '10px' }} /> : ""}
                                                </div>

                                            </Form>
                                        </>)}


                                    </Formik>



                                </div>
                                <p class="text-center">Need Any Help? <a data-toggle="tab" onClick={initModal} >Click Here</a></p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={isShow}>
                <Modal.Header closeButton onClick={closeModal}>
                    <Modal.Title>Software Support</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="card  text-dark bg-light mb-3">
                        <div class="card-header">
                            <div className="row">
                                <div className="col-12">
                                    <h6><i class="bi bi-phone"></i> Contact Information</h6>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div className="row">
                                <div className="col-6">
                                    <div class="card">
                                        <div class="card-body">
                                            <h5 class="card-title">Support</h5>
                                            <h6 class="card-subtitle mb-2" style={{ color: 'transparent' }}>Manager</h6>
                                            <h6 class="card-subtitle mb-2 text-muted">Software Support</h6>
                                            <a className="mt-2" href='mailto:support.sw@bitopibd.com'><i class="bi bi-envelope-check"></i> support.sw@bitopibd.com</a>
                                            <a className="mt-2 m-3" href='#'><i class="bi bi-phone"></i> +880 1623466666</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div class="card">
                                        <div class="card-body">
                                            <h5 class="card-title">Dewan Sanjida Rahman</h5>
                                            <h6 class="card-subtitle mb-2">Management Trainee (OD&Training)</h6>
                                            <h6 class="card-subtitle mb-2 text-muted">HR , Admin & Compliance</h6>
                                            <a className="mt-2" href='mailto:sanjida.rahman@bitopibd.com'><i class="bi bi-envelope-check"></i> sanjida.rahman@bitopibd.com</a>
                                            <a className="mt-2 m-3" href='#'><i class="bi bi-phone"></i> +880 1871001252</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={closeModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </section>
    )
}

export default Login